import { Translation } from '@/components/foundation/Translation'
import { DisplayLines } from '@/components/map/render/Popup/PopupContent/PopupContentStop'
import stylesOrigin from '@/components/map/render/Popup/PopupContent/PopupContentStop.scss'
import { useStringParam } from '@/hooks/useParam'
import { useSelector } from '@/stores/hooks'
import { getAllStops } from '@/stores/stops'
import { Area } from '@common/types/Area'
import { Stop } from '@common/types/Stop'
import styles from '@project/components/map/render/Popup/PopupContent/PopupContentStop.scss'
import { mixinStyles } from '@project/mixin'

__EXEC(() => {
  mixinStyles(stylesOrigin, styles)
})

function DisplayContent({ stop, areaId, isStop }: { stop: Stop | Area; areaId: string; isStop: boolean }) {
  const [area] = useStringParam('area', '')
  const stops = useSelector(getAllStops)
  const stopPoints = Object.values(stops).filter(stop => stop.stopArea === area)

  function getMostFrequentFareZone(stopPoints: Stop[]) {
    const counts = new Map<string, number>()
    let maxFareZone: string | null = null
    let maxCount = 0

    for (const point of stopPoints) {
      const fareZone = point.properties?.fare_zone
      if (fareZone !== undefined) {
        const count = (counts.get(fareZone) || 0) + 1
        counts.set(fareZone, count)

        if (count > maxCount) {
          maxCount = count
          maxFareZone = fareZone
        }
      }
    }

    return maxFareZone
  }

  return (
    <>
      {(stop.properties.fare_zone || stopPoints.some(stopPoint => stopPoint.properties.fare_zone)) && (
        <div className={styles.fareZoneContainer}>
          <Translation
            html
            id="popup:fare-zone"
            fareZone={stop.properties.fare_zone ?? getMostFrequentFareZone(stopPoints)}
          />
        </div>
      )}
      <DisplayLines elements={stop.lines} stopId={stop.id} areaId={areaId} type={isStop ? 'stop' : 'area'} />
    </>
  )
}

__OVERRIDE(styles)
__OVERRIDE(DisplayContent)
